import * as React from 'react';

import {Popover} from '../../popover/popover';
import {Body} from '../../typography/body';

import styles from './info-popover.module.css';

type Props = {
    text: string;
    anchor: HTMLElement | null | undefined;
};

export function InfoPopover(props: Props) {
    return (
        <Popover anchor={props.anchor} location='top' bodyColor='dark'>
            <div className={styles['popover-content']}>
                <Body size='small' color='white'>
                    {props.text}
                </Body>
            </div>
        </Popover>
    );
}
